/**
* Blog namespace
* @type {Object}
*/
SDG.Blog = SDG.Blog || {};


/**
* run dom ready
* @type {Function}
*/
SDG.Blog.run = function(){
  
  //var loadMore = document.querySelector('.load-more-articles__btn');

  // Sticky menu
  window.addEventListener('scroll', SDG.Blog.stickyMenu);
  
  // Mob menu
  SDG.Blog.mobileMenu();
  
  // Load more articles btn
  SDG.Blog.loadMoreArticles();
  
};

/**
* Sticky blog menu
*/
SDG.Blog.stickyMenu = function(){

// Get the navbar
var navbar = document.getElementById('blog-navbar');
  
//Add the sticky class to the navbar when you reach its scroll position.
//Remove "sticky" when you leave the scroll position
  
    if(navbar){
        // Get the offset position of the navbar
        var sticky = navbar.offsetTop;
        if (window.pageYOffset >= sticky + 10) {
            navbar.classList.add('sticky-menu');
          } else {
            navbar.classList.remove('sticky-menu');
          }
    }
};

/**
* Blog Mobile filter menu
*/
SDG.Blog.mobileMenu = function(){
  
  var mobBtn = document.getElementById('dropdown-btn'),
      mobConteiner = document.querySelector('.blog-dropdown-content'),
      arrowUp = document.querySelector('.chevron-up'),
      arrowDown = document.querySelector('.chevron-down');
  
  var clickEvent = (function() {
    if ('ontouchstart' in document.documentElement === true)
      return 'touchstart';
    else
      return 'click';
  })();


  if(mobBtn){
      mobBtn.addEventListener(clickEvent, function(e){
          e.stopPropagation();

          if( mobConteiner.style.display === 'block' ){
              mobConteiner.style.display = 'none';
          } else {
              mobConteiner.style.display = 'block';
          }

          if(arrowUp.style.display === 'block' &&  arrowDown.style.display === 'none'){
              arrowUp.style.display = 'none';
              arrowDown.style.display = 'block';
          } else {
              arrowUp.style.display = 'block';
              arrowDown.style.display = 'none';
          }
      });
  }

};

/**
* Show more articles button
*/
SDG.Blog.loadMoreArticles = function() {
  var articles_on_page = $('.articles-on-page'),
	  next_url = articles_on_page.data('next-url'),
  	  load_more_box = $('.load-more-articles'),
      load_more_btn = $('.load-more-articles__btn'),
      load_more_spinner = $('.load-more-articles__spinner');
  
  function loadMoreArticles(){  
     $.ajax(
            {
                url: next_url,
                type: 'GET',
                dataType: 'html',
                beforeSend: function() {
                    load_more_btn.hide();
                    load_more_spinner.show();
                }
            }
        ).done(function(next_page) {

            load_more_spinner.hide();

        var new_articles = $(next_page).find('.articles-on-page');
        var new_url = new_articles.data('next-url');

          if(new_url){
              load_more_btn.show();
          } else {
              load_more_box.hide();
          }
        next_url = new_url;
        new_articles.find('.single-article').first().attr('new-loaded', "true");
        articles_on_page.append(new_articles.html());
        setTimeout(function(){
          $('[new-loaded="true"]').last().find('.single-article__inner > a').focus();
        }, 500);
        });
		
	};
     
  if(load_more_btn){
    
  	 load_more_btn.click(loadMoreArticles);
  }
};

/**
* fire function
*/

SDG.Blog.run();